module.exports = __webpack_public_path__ + "img/sankaku_74_red.558613c8.png";